<script lang="ts">

    export let number: number | null;
    export let featured: boolean;
    export let fontSizeRatio = 0.7;
    export let borderWidthRatio = 0.04;

    let width: number = 100;

</script>

{#if number}
    <div class="number" bind:clientWidth={width}>
        <div class="circle" class:featured style="font-size: {width * fontSizeRatio}px; border-width: {width * borderWidthRatio}px">
            {number}
        </div>
    </div>
{/if}

<style lang="scss">

    .number {
        width: 100%;
        position: relative;

        &::before {
            content: '';
            display: block;
            padding-top: 100%;
        }
    }

    .circle {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #222;
        border: 5px solid #fff;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;

        &.featured {
            border: none;
            background-color: var(--color-secondary);
            color: #000;
        }
    }

</style>
